export let DEFAULT_LOGO_PATH = 'assets/images/logos/';
export const DEFAULT_LOGO_UNKNOWN = 'logo_not-found.png';

export function setLogoPath(path: string) {
  DEFAULT_LOGO_PATH = path;
}

export function providerImage(providerName: string): string {
  switch (providerName) {
    // AU & NZ providers
    case 'Adelaide':
    case 'Adelaide Bank':
      return 'logo_adelaidebank.png';
    case 'Alex.Bank':
      return 'logo_alexbank.png';
    case 'Bendigo':
    case 'Bendigo Commercial':
    case 'Bendigo Bank':
      return 'logo_bendigo.png';
    case 'AMP':
    case 'AMP Bank':
    case 'AMP Financial Services':
    case 'AMP Insurance':
      return 'logo_amp.png';
    case 'ANZ':
    case 'ANZ Commercial':
    case 'ANZ Bank':
      return 'logo_anz.png';
    case 'Bank SA':
    case 'Bank SA Commercial':
      return 'logo_banksa.png';
    case 'Bankwest':
      return 'logo_bankwest.png';
    case 'BOM':
    case 'Bank Of Melbourne':
    case 'Bank of Melbourne':
    case 'Bank of Melbourne Commercial':
      return 'logo_bankofmelbourne.png';
    case 'BOQ':
    case 'Bank Of Queensland':
    case 'Bank of Queensland':
    case 'BOQ Commercial Specialist':
      return 'logo_boq.png';
    case 'CBA':
    case 'CommBank':
    case 'Commonwealth Bank of Australia':
    case 'CBA Commercial':
      return 'logo_cba.png';
    case 'Firefighters Mutual Bank':
      return 'logo_firefightersmutualbank.png';
    case 'Firstmac':
    case 'Firstmac Commercial':
      return 'logo_firstmac.png';
    case 'Health Professionals Bank':
      return 'logo_healthprofessionalsbank.png';
    case 'Heritage':
      return 'logo_heritagebank.png';
    case 'ING':
    case 'ING Direct':
    case 'ING Commercial':
      return 'logo_ing.png';
    case 'Keystart':
    case 'Keystart Loans':
      return 'logo_keystart.png';
    case 'Liberty':
    case 'Liberty Commercial':
    case 'Liberty Financial Limited':
      return 'logo_liberty.png';
    case 'Latitude Financial Services':
    case 'Latitude':
      return 'logo_latitude.png';
    case 'La Trobe Financial':
    case 'La Trobe Commercial':
      return 'logo_latrobefinancial.png';
    case 'Macquarie':
    case 'Macquarie Bank':
    case 'Macquarie Commercial':
      return 'logo_macquarie.png';
    case 'ME Bank':
    case 'ME':
      return 'logo_mebank.png';
    case 'MoneyPlace':
      return 'logo_money-place.png';
    case 'My State':
      return 'logo_mystate.png';
    case 'NAB':
    case 'National Australia Bank':
    case 'NAB Commercial':
      return 'logo_nab.png';
    case 'COG':
      return 'logo_nfc.png';
    case 'nMB Direct':
      return 'logo_nmb_direct.png';
    case 'Paramount':
      return 'logo_paramount.png';
    case 'Resimac':
    case 'Resimac Commercial':
      return 'logo_resimac.png';
    case 'St George':
    case 'St. George':
    case 'St George Bank':
    case 'St. George Bank':
    case 'St George Commercial':
      return 'logo_stgeorge.png';
    case 'Suncorp':
    case 'Suncorp Bank':
    case 'Suncorp Commercial':
      return 'logo_suncorp.png';
    case 'Teachers Mutual Bank':
      return 'logo_teachersmutual.png';
    case 'UniBank':
      return 'logo_unibank.png';
    case 'Virgin Money':
    case 'Virgin Money Commercial':
      return 'logo_virgin.png';
    case 'Westpac':
    case 'Westpac Bank':
    case 'Westpac Commercial':
      return 'logo_westpac.png';
    //NZ only providers
    case 'ASB':
      return 'logo_asb.png';
    case 'Heartland':
    case 'Heartland Bank': 
      return 'logo_hbs.png';
    case 'National':
      return 'logo_nationalbank.png';
    case 'SBS':
      return 'logo_sbsbank.png';
    case 'Sovereign':
    case 'Sovereign Assurances':
      return 'logo_sovereign.png';
    case 'Co-operative Bank':
      return 'logo_cooperative.png';
    case 'AIA New Zealand':
      return 'logo_aia.png';
    case 'Asteron Life':
      return 'logo_asteron.png';
    case 'Fidelity Life':
      return 'logo_fidelity.png';
    case 'Aon New Zealand':
      return 'logo_aon.png';
    case 'Avanti Finance':
      return 'logo_avanti_finance.png';
    case 'Cressida Capital':
      return 'logo_cressida_finance.png';
    case 'DBR':
      return 'logo_dbr.png';
    case 'OnePath':
      return 'logo_onepath.png';
    case 'Fisher Funds':
      return 'logo_fisherfund.png';
    case 'MBG':
      return 'logo_mbg.png';
    case 'NBS':
      return 'logo_nbs.png';
    case 'NZCU':
    case 'Credit Union Baywide':
      return 'logo_nzcu.png';
    case 'SCFL':
      return 'logo_sxf.png';
    case 'Mike Pero':
      return 'logo_mikepero.png';
    case 'BNZ':
      return 'logo_bnz.png';
    case 'Pepper':
    case 'Pepper Money':
    case 'Pepper Commercial':
      return 'logo_peppermoney.png';
    case 'Citibank':
    case 'Citibank Commercial':
      return 'logo_citibank.png';
    case 'RedZed':
    case 'RedZed Commercial':
      return 'logo_redzed.png';
    case 'Assetline Capital Commercial':
      return 'logo_assetline_capital.png';
    case 'Judo Bank Commercial':
      return 'logo_judo.png';
    case 'Moula':
      return 'logo_moula.png';
    case 'Chubb':
      return 'logo_chubb.png';
    case 'Resolution Life':
      return 'logo_resolution_life.png';
    case 'Partners Life':
      return 'logo_partners_life.png';
    case 'ASAP Finance':
      return 'logo_asap_finance.png';
    case 'NIB':
      return 'logo_nib.png';
    case 'Southern Cross Healthcare':
      return 'logo_southern_cross.png';
  }

  return DEFAULT_LOGO_UNKNOWN;
}

export function doesProviderImageExists(providerName: string): boolean {
  return providerImage(providerName) !== DEFAULT_LOGO_UNKNOWN;
}
